import React, { useState, useCallback, useEffect } from 'react'
import Cropper from 'react-easy-crop'
import getCroppedImg from './crop-function';
import { useSelector, useDispatch } from 'react-redux';
import {setOpenDialogBox, uploadImageAPI} from '../reducers/global-reducer'
import '../index.css';

const ImageCropper = ({ imageUrl, imageState }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const store = useSelector(state => state);
    const dispatch = useDispatch();
    const onCropComplete = useCallback((croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const handleImageCrop = useCallback(async () => {
        try {
        const croppedImage = await getCroppedImg(
            imageUrl,
            croppedAreaPixels,
            0
        )
        const base64ImageString = croppedImage.substring(23)
        dispatch(uploadImageAPI({
            filename: new Date() + store.globalreducer.uploadImageFileName ,
            filedata: base64ImageString
        }))
       
        dispatch(setOpenDialogBox(false))
        } catch (e) {
        console.error(e)
        }
    }, [croppedAreaPixels, 0])

    useEffect(() => {
        if(imageState === "crop"){
            handleImageCrop()
        }
    }, [ imageState ])

    return (
        <>
            <div className="App">
                <div className="crop-container">
                    <Cropper
                    image={imageUrl}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 4}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    />
                </div>
                <div className="controls">
                    <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => {
                        setZoom(e.target.value)
                    }}
                    className="zoom-range"
                    />
                </div>
            </div>
        </>
    )
}

export default ImageCropper;